/**
 * WindowListenable.js
 * Window listner helper
 *
 * @module  WindowListener
 * @author  Randy Lebeau
 *
 */

var Events = require('../../utils/events');

module.exports = {

	componentDidMount: function() {
		var listeners = this.windowListeners;

		for (var eventName in listeners) {
			var callbackName = listeners[eventName];
			Events.on(window, eventName, this[callbackName]);
		}
	},

	componentWillUnmount: function() {
		var listeners = this.windowListeners;

		for (var eventName in listeners) {
			var callbackName = listeners[eventName];
			Events.off(window, eventName, this[callbackName]);
		}
	}

}



/** WEBPACK FOOTER **
 ** ./src/mixins/js/WindowListeners.js
 **/